import Util from "@/js/common/Util"
import React from "react"

interface codeInfoProps {
    name: string
    code: string
}
interface RadioBoxProps {
    codeList: codeInfoProps[]
    value: string
    setValue?: React.Dispatch<React.SetStateAction<string>>
    btnColor?: string
    btnSize?: number
    btnClass: string
    labelClass: string
    singleWidth?: number
    interval: number
    onChange?: Function
    disabled?: boolean
    disabledVals?: string[]
    filterVals?: string[]
    flexDirection?: "column" | "row"
}
const RadioBox = ({codeList, value, setValue, btnColor, btnSize, btnClass, labelClass, interval, singleWidth, onChange, disabled, disabledVals, filterVals, flexDirection}: RadioBoxProps) => {
    return (
        <div className="dpFlx" style={{flexDirection: flexDirection ? flexDirection : "row", alignItems: flexDirection === "row" ? "center" : "flex-start"}}>
            {codeList.map((codeInfo: any, i: number) => {
                if (Util.isNotEmpty(filterVals)) {
                    if (Array.isArray(filterVals)) {
                        if (filterVals.indexOf(codeInfo.code) === -1) {
                            return <div key={i}></div>
                        }
                    }
                }
                let dsbFlag = false;
                if (disabledVals !== undefined) {
                    for (const disabledVal of disabledVals) {
                        if (disabledVal === codeInfo.code) {
                            dsbFlag = true;
                            break;
                        }
                    }
                }
                return (
                    <button key={i} style={{marginRight: interval, width: (Util.isEmpty(singleWidth) ? "auto" : singleWidth)}} className="dpFlx aiC csP bdN bgcTp p0" onClick={() => {
                        if (disabled || dsbFlag) {
                            return;
                        }
                        if (setValue !== undefined) {
                            setValue(codeInfo.code);
                        }
                        if (onChange !== undefined) {
                            onChange(codeInfo.code);
                        }
                    }}>
                        {/* <img className={btnClass} src={Util.getImgSrc('common/radiobutton_base_' + (value === codeInfo.code ? 'on' : 'off') + '.png')} alt="radiobutton_base" /> */}
                        <input
                            type="radio"
                            value={value}
                            checked={value === codeInfo.code}
                            disabled={disabled}
                            className={"p0 m0 csP zIdx0 " + btnClass}
                            style={{
                                appearance: "none",
                                width: btnSize ? btnSize : 15,
                                height: btnSize ? btnSize : 15,
                                boxShadow: "0 0 0 1px #666666",
                                border: "3px solid #ffffff",
                                borderRadius: "50%",
                                background: (value === codeInfo.code ? (btnColor ? btnColor : "black") : "white")
                            }}
                            readOnly
                        />
                        <span className={(disabled || dsbFlag ? "fcBDBDBD-i " : "") + labelClass}>{codeInfo.name}</span>
                    </button>
                )
            })}
        </div>
    )
};
export default RadioBox;